import { useState } from 'react'
import { CenteredBox, H3 } from './'

export const Interaction = () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  const isFirefox = navigator.userAgent.includes("Firefox")
  const [visible, setVisible] = useState(isFirefox || isSafari)

  return visible
    ? <CenteredBox
      position="fixed"
      inset
      background="rgba(0, 0, 0, 0.7)"
      onClick={() => setVisible(false)}
      cursor="pointer"
      zIndex={100}
    >
      <H3>Click to enable sound</H3>
    </CenteredBox>
    : null
}